import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader, FormGroup, Input, Label, Col, Row} from "reactstrap";
import { setSearchData } from '../../../actions/search';

import lodash  from 'lodash';

import {withRouter} from 'react-router';
import classnames from 'classnames';
import Addresses from '../Addresses';
import Select from 'react-select';
import { updateClient } from '../../../actions/clientData';
import { editingInProgress } from '../../../actions/loaderAction';
import { CircularProgress } from 'material-ui/Progress';
class Form extends Component {

    constructor(props,context) {
        super(props,context);

        this.state = {
            activeTab: '1',
            selectedValues: false
        };

        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateField = this.updateField.bind(this);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    componentWillMount() {
        const clientId = this.props.match.params.clientId;
        if(clientId) {

            // -- get client from state

            const client = this.props.clientData.data.find(e => e.id === clientId);

            const clientIndex = lodash.findIndex(this.props.clientData.data, function(value) { return value.id === clientId; });

            this.setState({
                client: client,
                clientIndex: clientIndex,
                selectedValues: client.representatives ? client.representatives : false
            })
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    componentDidUpdate(prevProps) {
        if(prevProps.clientData.data != this.props.clientData.data) {
            const clientId = this.props.match.params.clientId;
            if(clientId) {
    
                // -- get client from state
    
                const client = this.props.clientData.data.find(e => e.id === clientId);
    
                const clientIndex = lodash.findIndex(this.props.clientData.data, function(value) { return value.id === clientId; });
    
                this.setState({
                    client: client,
                    clientIndex: clientIndex,
                    selectedValues: client.representatives ? client.representatives : false
                })
            }
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        //this.props.editingInProgress(true);
        this.props.updateClient(
            this.props.clientPath.clientPath + '/api/clients/action/updateClient',
            this.state.client.customer_id,
            this.state.client,
            this.state.clientIndex,
            this.state.selectedValues
        );
    }

    updateField(e) {
        const value = e.target.value;
        const key = e.target.getAttribute("name");
        let client = this.state.client;

        client[key] = value;

        this.setState({
            client: client
        })

    }

    mapMetaSelectValues(valueObject) {
        return ({value: valueObject.id, label: valueObject.name})
    }

    setSelectedValue(value) {
        // -- set local state
        this.setState({selectedValues: value})

    }

    updateParentUserField(value) {
        // -- set local state
        let client = this.state.client;

        client['user_id'] = value;
        this.setState({
            client: client
        })
    }

    render() {

        return (
            <div className="animated fadeIn">
                <div className="row">
                    <div className="col-md-12">
                        <Card>
                            <CardHeader>
                                <strong>Klant</strong> {this.state.client ? 'bewerken' : 'Toevoegen'}
                            </CardHeader>
                            <CardBody>
                                <form action="" method="post" onSubmit={this.handleSubmit}>
                                    <FormGroup row>
                                        <Label sm={3} for="name">Klant</Label>
                                         <Col sm={9}>
                                            <input type="hidden" id="id" ref="id" name="id" className="form-control" defaultValue={this.state.client ? this.state.client.id : ''}/>
                                            <input type="text" readOnly="readonly" onChange={this.updateField} id="name" ref="name" name="name" className="form-control" placeholder="Naam invoeren" defaultValue={this.state.client ? this.state.client.name : ''}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label sm={3} for="customer_id">Klantnummer</Label>
                                        <Col sm={9}>
                                            <input type="text" readOnly="readonly" onChange={this.updateField} id="customer_id" ref="customer_id" name="customer_id" className="form-control" placeholder="Klantnummer invoeren" defaultValue={this.state.client ? this.state.client.customer_id : ''}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label sm={3} for="representative">Vertegenwoordiger</Label>
                                        <Col sm={9}>
                                             <Select
                                                simpleValue={true}
                                                multi={true}
                                                value={this.state.selectedValues}
                                                onChange={value => this.setSelectedValue(value)}
                                                options={lodash.filter(this.props.frontEndUserData.data, {is_representative: '1'}).map((value) => this.mapMetaSelectValues(value))}
                                              />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label sm={3} for="user_id">Hoofdgebruiker</Label>
                                        <Col sm={9}>
                                        <Select
                                            simpleValue={true}
                                            name="form-field-name"
                                            value={this.state.client ? this.state.client.user_id : ""}
                                            onChange={(value) => this.updateParentUserField(value)}
                                            name="user_id"
                                            id="user_id"
                                            options={this.props.frontEndUserData.data.map((value) => this.mapMetaSelectValues(value))}                                        
                                        
                                        />
                                            
                                         
                                        </Col>
                                    </FormGroup>
                                    <Row>
                                        <Col sm={12}>
                                            { this.props.isEditingInProgress === true ? <CircularProgress size={16}  /> : <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-dot-circle-o"></i> {this.state.client ? 'Bijwerken' : 'Toevoegen'}</button> }
                                    {/*<div className="form-group row">
                                        <label className="col-md-3 form-control-label">Is actief?</label>
                                        <div className="col-md-9">
                                            <div className="checkbox">
                                                <label htmlFor="is_active">
                                                    <input type="checkbox" onChange={this.updateField} ref="is_active" id="is_active" name="is_active" defaultChecked={this.state.client.is_active === '1' ? true : false}/>
                                                </label>
                                            </div>
                                        </div>
                                    </div> */}
                                    </Col>
                                    </Row>
                                </form><br />
                                <Addresses addresses={this.state.client.addresses}/>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer,
        clientPath: state.clientPathReducer ,
        frontEndUserData: state.FrontEndUserReducer,
        isEditingInProgress: state.LoaderReducer.EditingInProgress,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        editingInProgress : (status) => dispatch(editingInProgress(status)),
        updateClient: (url, clientId, postData, clientIndex, selectedRepresentatives) => dispatch(updateClient(url, clientId, postData, clientIndex, selectedRepresentatives))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form))



// WEBPACK FOOTER //
// ./src/views/Clients/Form/index.js